module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/employer/list.component.css
// module id = ./src/app/views/employer/list.component.css
// module chunks = main